import React, { Fragment } from 'react';
import { hasAny } from '../utils';

const Street = ({ street, number, aptNumber }) =>
  hasAny(street, number) ? (
    <div>
      {street}
      {hasAny(street, number) && ' '}
      {number}
      {!!aptNumber && ' '}
      {!!aptNumber && aptNumber}
    </div>
  ) : null;

const Address = ({ address1, address2 }) => (
  <Fragment>
    <div>{address1}</div>
    <div>{address2}</div>
  </Fragment>
);

const Default = ({
  street,
  number,
  aptNumber,
  address1,
  address2,
  city,
  zipcode,
  regionCode,
  regionName,
  countryName,
}) => {
  const addressMarkup = hasAny(street, number) ? (
    <Street street={street} number={number} aptNumber={aptNumber} />
  ) : (
    <Address address1={address1} address2={address2} />
  );

  const territoryMarkup = hasAny(city, zipcode) && (
    <div>
      {zipcode} {city}
    </div>
  );

  const regionMarkup = hasAny(regionCode, regionName) && <div>{regionName || regionCode}</div>;

  return (
    <Fragment>
      {addressMarkup}
      {territoryMarkup}
      {regionMarkup}
      {!!countryName && <div>{countryName}</div>}
    </Fragment>
  );
};

export default Default;
